import React, { useContext, useLayoutEffect } from "react";
import OverviewSection from "./OverviewSection";
import { ACTIONS, CheckoutContext, PAGES } from "../../CheckoutProvider";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useCartContext } from "../../../../global/cartContext";
import PAYMENT_OPTIONS from "~/assets/js/Helpers/paymentOptions";

const TypeOfPayment = ({ edit }) => {
    const { dispatch } = useContext(CheckoutContext);
    const { requiresPayment, cart } = useCartContext();
    const { iconPath } = reactConfig;

    useLayoutEffect(() => {
        if (requiresPayment && cart.payment === null) {
            dispatch({
                type: ACTIONS.CHANGE_PAGE,
                payload: PAGES.PAYMENT_SELECT,
            });
        }
    }, [requiresPayment]);

    if (!requiresPayment || cart.payment === null) {
        return null;
    }

    const selectedPayment = PAYMENT_OPTIONS.find(
        (payment) => payment.value === cart?.payment?.method
    );

    if (!selectedPayment) {
        return null;
    }

    const { icons, heading } = selectedPayment;

    return (
        <OverviewSection
            title="overview.payment"
            editPage={edit && PAGES.PAYMENT_SELECT}
        >
            <div className="togglebox togglebox_payment">
                <span className="togglebox__title">{i18next.t(heading)}</span>
                {icons.map((icon) => {
                    return (
                        <div className={"togglebox__icon"} key={icon}>
                            <img
                                src={`${iconPath}/${icon}`}
                                alt="icon"
                                key={icon}
                            />
                        </div>
                    );
                })}
            </div>
        </OverviewSection>
    );
};

TypeOfPayment.propTypes = {
    edit: PropTypes.bool,
};

export default TypeOfPayment;
